/**
 * Sichtbarkeit des Editor-Einstiegs (EditorLoginLauncher).
 *
 * Der Einstieg erscheint nur gezielt:
 *  - wenn die Adresse den Hash #editor-login enthält (https://<shop>/#editor-login), oder
 *  - wenn im sessionStorage der Sitzungs-Marker "editor-intent" gesetzt ist.
 * Ohne diese Anzeichen rendert der Launcher nichts (kein DOM, kein Layout-Platz).
 */

export const EDITOR_LOGIN_HASH = 'editor-login';
export const EDITOR_INTENT_KEY = 'editor-intent';

/**
 * Normalisiert einen Hash für den Editor-Marker: führendes '#' und '/' entfernen,
 * alles ab '?' oder '/' abschneiden, klein schreiben. Wird auch vom Router genutzt.
 * @param {string} hash
 * @returns {string}
 */
export function normalizeEditorHash(hash = '') {
  return String(hash || '').replace(/^#/, '').replace(/^\/+/, '').split(/[?/]/)[0].toLowerCase();
}

/**
 * Reine Entscheidung, testbar ohne Browser.
 * @param {{ hash?: string, storage?: { getItem(key: string): string | null } | null }} input
 * @returns {boolean}
 */
export function isEditorLauncherRequested({ hash = '', storage = null } = {}) {
  const normalizedHash = normalizeEditorHash(hash);
  if (normalizedHash === EDITOR_LOGIN_HASH) return true;
  try {
    return Boolean(storage && storage.getItem(EDITOR_INTENT_KEY));
  } catch {
    return false;
  }
}

/**
 * Browser-Wrapper: liest Hash und sessionStorage. Setzt den Marker, sobald
 * #editor-login aufgerufen wurde, damit der Einstieg in der Sitzung bleibt.
 * @returns {boolean}
 */
export function isEditorLauncherVisibleInBrowser() {
  if (typeof window === 'undefined') return false;
  const hash = window.location?.hash || '';
  let storage = null;
  try {
    storage = window.sessionStorage;
  } catch {
    storage = null;
  }
  const requested = isEditorLauncherRequested({ hash, storage });
  if (requested && storage && String(hash).toLowerCase().includes(EDITOR_LOGIN_HASH)) {
    try {
      storage.setItem(EDITOR_INTENT_KEY, '1');
    } catch {
      /* Speicher nicht verfügbar: nur Hash-Sichtbarkeit */
    }
  }
  return requested;
}
